import React, { useCallback, useEffect, useState } from "react";
import Description from "../news/Description";
import News from "../news/News";
import Nav from "../Nav";
import Footer from "../Footer";
import Dropdown from "../news/Dropdown";
import useHttp from "../hook/http";
import ErrorModal from "../UI/ErrorModal";
import { useSearch } from "../context/SearchContext";
import { toast } from "react-toastify";
import { useParams, useNavigate } from "react-router-dom";

function NewsPage() {
  const [news, setNews] = useState({ articles: [], totalPages: 1 });
  const [category, setCategory] = useState("");

  const { data, sendRequest, error, isLoading, clearError } = useHttp();
  const { query } = useSearch();
  const { pn } = useParams();
  const nav = useNavigate();

  const pageNumber = !isNaN(Number(pn)) && Number(pn) > 0 ? Number(pn) : 1;

  const buildUrl = useCallback(() => {
    const params = new URLSearchParams();
    params.append("page", pageNumber);
    params.append("limit", 12);

    if (query) {
      params.append("q", query);
      return `https://info-server.vercel.app/api/news/search?${params}`;
    }

    if (category) params.append("category", category);

    return `https://info-server.vercel.app/api/news/top-headlines?${params}`;
  }, [category, pageNumber, query]);

  useEffect(() => {
    const url = buildUrl();
    sendRequest(url).catch(() => {
      toast.error("Fetching went wrong!");
    });
  }, [buildUrl, sendRequest]);

  useEffect(() => {
    if (!data) return;

    setNews({
      articles: data.articles || [],
      totalPages: data.totalPages || 1,
    });
  }, [data]);

  const clickOption = (cat) => {
    setCategory(cat);
    nav("/page/1");
  };

  return (
    <>
      {error && (
        <ErrorModal
          msg={error}
          onClose={() => {
            clearError();
            nav("/top");
          }}
        />
      )}

      <Nav />
      <Description />
      <Dropdown onOption={clickOption} />

      <News
        news={news.articles}
        totalPages={news.totalPages}
        currentPage={pageNumber}
        isLoading={isLoading}
      />

      <Footer />
    </>
  );
}

export default NewsPage;